import _ from "lodash";
import React from "react";
import { FormNoticia } from "./MyForm";
import {
  useGetQueryParams,
  useGetNoticia,
  useGetSegmentos,
  useGetProgramas
} from "../hooks";
import { useState } from "react";
import { useEffect } from "react";
import { buildVariables } from "../helpers";
import AppGraphQl from "js/graphql/resolvers/noticia.resolver";
import { GQLParamBuilder } from "../../../../../helpers";
import { ErrorDetailDialog } from "../components/ErrorDetailDialog";

export const Edit = ({
  client,
  computedMatch,
  match,
  history,
  openNotification,
  classes
}) => {
  const [formParams, setFormParams] = useState({
    errors: null,
    initialValues: null,
    esPublico: false,
    openErrorDialog: false,
    noticiasConflicto: []
  });

  const [openDialog, setOpenDialog] = useState(false);

  const {
    inBackOffice,
    idPrograma,
    idNoticia,
    edit,
    disabled
  } = useGetQueryParams({
    match,
    computedMatch
  });

  const noticia = useGetNoticia({
    client,
    idPrograma,
    idNoticia,
    setFormParams
  });

  let segmentosTree = useGetSegmentos({
    client,
    idPrograma,
    setFormParams
  });

  let programa = useGetProgramas({
    client,
    idPrograma,
    setFormParams
  });

  useEffect(
    () => {
      let initialValues = {};

      if (!noticia && idNoticia !== "new") return;

      if (!programa) return;

      if (segmentosTree && segmentosTree.length <= 0) return;

      const { esPublico } = programa;

      initialValues = {
        idPrograma,
        idNoticia: parseInt(idNoticia) || idNoticia,
        fechaInicio: Date.now(),
        fechaFin: Date.now(),
        frecuenciaDiaria: 0,
        limiteDiasVisualizacion: 0,
        requiereLogin: false,
        segmentosTree,
        segmentosSecciones: []
      };

      if (!_.isNil(noticia)) {
        const {
          programa: { idPrograma },
          idNoticia,
          nombre,
          fechaInicio,
          fechaFin,
          template,
          limiteDiasVisualizacion,
          frecuenciaDiaria,
          segmentos,
          requiereLogin
        } = noticia;

        segmentos.forEach(seg => {
          let nodePadre = segmentosTree.find(
            node => node.value === seg.segmento.idSegmento
          );
          if (nodePadre) {
            const { children } = nodePadre;
            if (children && children.length > 0) {
              children.forEach(child => {
                if (seg.secciones && seg.secciones.includes(child.value)) {
                  child.checked = true;
                }
              });
            }
          }
        });

        initialValues = {
          ...initialValues,
          idPrograma,
          idNoticia,
          nombre,
          fechaInicio,
          fechaFin,
          template,
          limiteDiasVisualizacion,
          frecuenciaDiaria,
          segmentosTree,
          segmentosSecciones: segmentos,
          requiereLogin
        };
      }

      setFormParams({
        ...formParams,
        esPublico,
        initialValues
      });
    },
    [noticia, programa, segmentosTree.length]
  );

  const handleCloseDialog = value => {
    setFormParams({
      ...formParams,
      errors: null,
      openErrorDialog: false
    });
  };

  const submit = async values => {
    try {
      const opBuilder = new GQLParamBuilder(client);

      opBuilder.setIsMutation(); //* Ejecutaré una mutation

      const { createNoticia, updateNoticia } = AppGraphQl.mutations;

      opBuilder.setOperation(
        values.idNoticia === "new" ? createNoticia : updateNoticia
      );

      let noticiaVars = {};

      if (values.idNoticia === "new") {
        noticiaVars.idPrograma = parseInt(idPrograma) || idPrograma;
      } else {
        noticiaVars.idPrograma =
          parseInt(values.idPrograma) || values.idPrograma;
        noticiaVars.idNoticia = parseInt(idNoticia) || idNoticia;
      }

      noticiaVars = {
        ...noticiaVars,
        ...buildVariables(values),
        idUsuarioCreador: parseInt(localStorage.getItem("idUsuario")),
        segmentos: values.segmentosSecciones
      };
      opBuilder.setVariables({ noticia: { ...noticiaVars } });

      let res = await opBuilder.exec();

      openNotification("Noticia grabada correctamente");

      const idNoticiaUpdate =
        res.data.updateNoticia && res.data.updateNoticia.idNoticia;
      const idNoticiaCreate =
        res.data.createNoticia && res.data.createNoticia.idNoticia;

      const id = idNoticiaUpdate || idNoticiaCreate;

      if (inBackOffice) {
        if (idPrograma) {
          history.push(
            `/admin/programa/${parseInt(idPrograma) ||
              idPrograma}/noticias/${parseInt(id) || id}/edit`
          );
          if (idNoticiaUpdate)
            setTimeout(() => {
              history.push(
                `/admin/programa/${parseInt(idPrograma) || idPrograma}/noticias`
              );
            }, 1000);
        }
      }
    } catch (errors) {
      const { graphQLErrors = [] } = errors;
      let paramsToSet = {};

      if (graphQLErrors.length > 0) {
        const { extensions, message } = graphQLErrors[0];

        if (extensions.code === "NOTICIA_CONFLICTO") {
          paramsToSet = {
            openErrorDialog: true,
            errors: {
              noticiasConflicto: extensions.details,
              message
            }
          };
        }
        setFormParams({
          ...formParams,
          ...paramsToSet
        });
      } else {
        let errorMessages = graphQLErrors.map(err => err.message);

        for (const message of errorMessages) {
          openNotification(message);
        }
      }
    }
  };

  return (
    <>
      <FormNoticia
        disabled={disabled}
        initialValues={formParams.initialValues}
        esPublico={formParams.esPublico}
        onSubmit={submit}
        history={history}
        classes={classes}
      />
      {formParams.openErrorDialog && (
        <ErrorDetailDialog
          openDialog={formParams.openErrorDialog}
          errors={formParams.errors}
          onClose={handleCloseDialog}
        />
      )}
    </>
  );
};
